export default "__VITE_ASSET__DtUZ5ps2__"